import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'About', path: '/about' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md py-4' : 'bg-transparent py-6'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        <Link to="/" className="flex items-center">
          <img 
            src="https://public.readdy.ai/ai/img_res/ce7e038c-0861-4277-bb69-958f0a8f80a8.png" 
            alt="Riverdale Hair Studio" 
            className="h-12 w-auto"
          />
        </Link>

        <ul className="flex items-center gap-8">
          {navLinks.map((link) => (
            <li key={link.path}>
              <Link
                to={link.path}
                className={`font-sans text-sm font-medium transition-colors cursor-pointer ${
                  location.pathname === link.path
                    ? 'text-sage'
                    : isScrolled
                    ? 'text-charcoal hover:text-sage'
                    : 'text-white hover:text-cream'
                }`}
              >
                {link.name}
              </Link>
            </li>
          ))}
        </ul>

        <a
          href="/contact"
          className="px-6 py-2.5 bg-sage text-white font-sans text-sm font-medium rounded-full hover:bg-sage-dark transition-all whitespace-nowrap cursor-pointer"
        >
          Book Now
        </a>
      </div>
    </nav>
  );
};

export default Navbar;